/* assets/ribbon-overlay.js
 * ---------------------------------------------------------------------------
 * Overlays the selected ribbon product's image on top of the medal image.
 *
 * Places an overlay inside EVERY slide of the main product media gallery
 * (not just the active one) so the ribbon is visible on every image — on the
 * desktop gallery AND the mobile swiper, across all colour/media slides.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var NO_RIBBON = ['no ribbon', 'none', 'no', '', 'select'];
  function isNoRibbon(v) {
    return !v || NO_RIBBON.indexOf(String(v).trim().toLowerCase()) !== -1;
  }

  var template = null;      // the original overlay rendered by the snippet (also acts as clone source)
  var optionName = 'Ribbon';
  var section = '';
  var lowerMap = {};
  var applying = false;     // suppress our own mutations from re-triggering the observer

  function findTemplate() {
    return document.querySelector('[data-ribbon-overlay]');
  }

  function buildMap() {
    var map = (window.RibbonOverlayMaps && window.RibbonOverlayMaps[section]) || {};
    lowerMap = {};
    Object.keys(map).forEach(function (k) {
      lowerMap[k.toLowerCase()] = map[k];
    });
  }

  function currentValue() {
    var s = document.querySelector('select[name="options[' + optionName + ']"]');
    if (s) return s.value;
    var r = document.querySelector('input[name="options[' + optionName + ']"]:checked');
    if (r) return r.value;
    // Fallback: any ribbon-named control
    var selects = document.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].name && selects[i].name.toLowerCase().indexOf('ribbon') !== -1) return selects[i].value;
    }
    return null;
  }

  // URL of the currently-selected ribbon image (null = hide).
  function currentUrl() {
    var v = currentValue();
    if (isNoRibbon(v)) return null;
    return lowerMap[String(v).trim().toLowerCase()] || null;
  }

  // Every slide container in the MAIN gallery (excludes the zoom modal).
  function mediaContainers() {
    var list =
      document.querySelector('.product__media-list') ||
      document.querySelector('media-gallery .slider');
    if (!list) {
      // Last resort: overlay whatever single container exists.
      var one = document.querySelector('.product-media-container');
      return one ? [one] : [];
    }
    return Array.prototype.slice.call(list.querySelectorAll('.product-media-container'));
  }

  // Ensure a container has its own overlay; return its <img>.
  function ensureOverlayIn(container) {
    var ov = container.querySelector(':scope > [data-ribbon-overlay]') ||
             container.querySelector('[data-ribbon-overlay]');
    if (ov && ov.parentElement !== container) {
      // an overlay exists but is nested wrongly — move it to the container root
      container.appendChild(ov);
    }
    if (!ov) {
      ov = (template || findTemplate());
      if (!ov) return null;
      ov = ov.cloneNode(true);
      ov.removeAttribute('aria-hidden');
      container.appendChild(ov);
    }
    return ov.querySelector('[data-ribbon-overlay-image]');
  }

  function render() {
    var url = currentUrl();
    var containers = mediaContainers();

    applying = true;
    try {
      for (var i = 0; i < containers.length; i++) {
        var img = ensureOverlayIn(containers[i]);
        if (!img) continue;
        var overlay = img.closest('[data-ribbon-overlay]');
        if (!url) {
          if (!overlay.hidden) overlay.hidden = true;
          if (img.getAttribute('src')) img.removeAttribute('src');
        } else {
          if (img.getAttribute('src') !== url) img.setAttribute('src', url);
          if (overlay.hidden) overlay.hidden = false;
        }
      }
    } finally {
      // reset after the observer's microtask so our writes above stay suppressed
      setTimeout(function () { applying = false; }, 0);
    }
  }

  function update() {
    if (!template || !document.body.contains(template)) {
      template = findTemplate();
    }
    render();
  }

  function bind() {
    if (window.__ribbonOverlayBound) return;
    window.__ribbonOverlayBound = true;

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'options[' + optionName + ']') update();
      else if (e.target && e.target.name && e.target.name.toLowerCase().indexOf('ribbon') !== -1) update();
    });

    document.addEventListener('variant:change', update);
    document.addEventListener('on:variant:change', update);
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, update);
        window.subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, update);
      } catch (e) {}
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest &&
          e.target.closest('.thumbnail, .slider-button, .product__media-item, media-gallery')) {
        setTimeout(update, 60);
      }
    });

    // The theme re-renders the gallery (Shopify Section Rendering) on variant
    // change, which recreates the slide containers and drops our overlays.
    // Re-inject whenever the gallery changes.
    var gallery = document.querySelector('media-gallery') ||
                  document.querySelector('.product__media-list');
    if (gallery && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (applying) return;
        if (pending) return;
        pending = setTimeout(function () { pending = null; update(); }, 50);
      }).observe(gallery, { childList: true, subtree: true });
    }
  }

  function init() {
    template = findTemplate();
    if (!template) return;
    optionName = template.getAttribute('data-ribbon-option-name') || 'Ribbon';
    section = template.getAttribute('data-ribbon-section') || '';
    buildMap();
    bind();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();